import React, { useState } from 'react';
import { RoundedSubHeader } from '../../components/Headings/Headings';
import { data } from "../../constants";
import './Faq.css';

export const Faq = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => setIsOpen(!isOpen);

  return (

    <div className="">
      <button className="faq-question" onClick={toggleOpen}>
        {question}
        <span className={isOpen ? 'arrow up' : 'arrow down'} />
      </button>
      {isOpen && <div className="faq-answer">
        {answer}
        <br/>
        <br/>
      </div>}
    </div>
  );
};

export const FaqList = ({ faqs, title = 'FAQ', text = 'Vanligt ställda frågor' }) => {
  const items = faqs || data.Faqs;

   return (
    <div className="faq-list">
      <RoundedSubHeader title={title} text={text} />
      <br></br>
      {items.map((faq, index) => (
        <Faq key={index} question={faq.question} answer={faq.answer} />
      ))}
      <br></br>
    </div>
  );
};